import { render, staticRenderFns } from "./ActiveTimeByTypeReefereComponent.vue?vue&type=template&id=741f36c1&scoped=true&"
import script from "./ActiveTimeByTypeReefereComponent.vue?vue&type=script&lang=js&"
export * from "./ActiveTimeByTypeReefereComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTimeByTypeReefereComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ActiveTimeByTypeReefereComponent.vue?vue&type=style&index=1&id=741f36c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741f36c1",
  null
  
)

export default component.exports